import { AfterViewInit, Component, ContentChildren, Input, QueryList } from "@angular/core";
import { CerrixAccordionComponent } from "./cerrix-accordion/cerrix-accordion.component";

@Component({
    selector: "cerrix-accordion-group",
    imports: [],
    template: "<ng-content />"
})
export class CerrixAccordionGroupComponent implements AfterViewInit {
    @Input() multiple: boolean = false;
    @ContentChildren(CerrixAccordionComponent)
    public accordions: QueryList<CerrixAccordionComponent>;

    ngAfterViewInit(): void {
        if (!this.multiple) {
            this.accordions.forEach((accordion) => {
                accordion.emitToggle.subscribe((isOpen) => {
                    this.collapseAll();
                    accordion.isOpen = isOpen;
                });
            });
        }
    }

    expandAll(): void {
        this.accordions.forEach((accordion) => {
            accordion.isOpen = true;
        });
    }

    collapseAll(): void {
        this.accordions.forEach((accordion) => {
            accordion.isOpen = false;
        });
    }
}
